import { render, staticRenderFns } from "./TftScreenshot.vue?vue&type=template&id=0883316c&scoped=true"
import script from "./TftScreenshot.vue?vue&type=script&lang=js"
export * from "./TftScreenshot.vue?vue&type=script&lang=js"
import style0 from "./TftScreenshot.vue?vue&type=style&index=0&id=0883316c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883316c",
  null
  
)

export default component.exports